import { projectLocalIfcObservation, type LocalIfcProjection } from "../domain/local-ifc-projection";
import {
  LOCAL_IFC_ARTIFACT,
  observeLocalIfc,
  type LocalIfcImporter,
  type LocalIfcObservation,
  type LocalIfcSource
} from "./local-ifc";

export const IFC_CAPABILITY_PROVIDER_CONTRACT_VERSION = "workbench-ifc-capability-provider/1" as const;

export interface IfcCapabilityProviderDescriptor {
  readonly contractVersion: typeof IFC_CAPABILITY_PROVIDER_CONTRACT_VERSION;
  readonly providerId: string;
  readonly implementationVersion: string;
  readonly executionKind: "wasm-web-runtime" | "native-sidecar";
  readonly artifact: {
    readonly packageName: string;
    readonly version: string;
    readonly sourceCommit: string;
    readonly archiveDigest: string;
    readonly wasmDigest: string;
  };
}

export interface IfcCapabilityProvider {
  readonly descriptor: IfcCapabilityProviderDescriptor;
  loadImporter(): Promise<LocalIfcImporter>;
  observe(importer: LocalIfcImporter, source: LocalIfcSource): Promise<LocalIfcObservation>;
  project(observation: LocalIfcObservation): LocalIfcProjection;
}

export const PINNED_IFC_BIM_JSON_0_1_90_PROVIDER: IfcCapabilityProvider = Object.freeze({
  descriptor: Object.freeze({
    contractVersion: IFC_CAPABILITY_PROVIDER_CONTRACT_VERSION,
    providerId: "ifc-bim-json-browser-wasm",
    implementationVersion: LOCAL_IFC_ARTIFACT.version,
    executionKind: "wasm-web-runtime",
    artifact: Object.freeze({
      packageName: LOCAL_IFC_ARTIFACT.packageName,
      version: LOCAL_IFC_ARTIFACT.version,
      sourceCommit: LOCAL_IFC_ARTIFACT.sourceCommit,
      archiveDigest: LOCAL_IFC_ARTIFACT.archiveDigest,
      wasmDigest: LOCAL_IFC_ARTIFACT.wasmDigest
    })
  }),
  loadImporter: async () => (await import("./ifc-wasm")).loadPinnedLocalIfcImporter(),
  observe: observeLocalIfc,
  project: projectLocalIfcObservation
});

export const DEFAULT_IFC_CAPABILITY_PROVIDER = PINNED_IFC_BIM_JSON_0_1_90_PROVIDER;
